/* eslint-disable */
import { produce } from "immer";
import isEqual from "lodash/isEqual";

import {
  specificBlockOptions,
  commonBlocksOptions,
  blocksOptionsConfig,
  defaultBlockSettings,
} from "@components/cmsBlocks/configs";

import {
  toggleEditMode,
  toggleSettings,
  toggleGeneral,
  toggleCreatePage,
  changePageLang,
  changeHeaderLang,
  changePage,
  getIsPublishedLang,
  hasSlug,
  updatePageDataField,
  updateIsPublishedPageForLang,
  updateIsPublishedPage,
  checkHasPageChanges,
  checkHasHeaderChanges,
  cancelPageChanges,
  cancelHeaderChanges,
  removeLang,
  removePage,
  updateSeoField,
  setTemplate,
  updateOrderBlocks,
  updateOrderHeaderGroupes,
  updateOrderHeaderSubLinks,
  toggleShowBlock,
  toggleShowHeaderSubLink,
  removeBlock,
  removeHeaderSubLink,
  addBlock,
  updateDataBlock,
  toggleActiveSeo,
  setActiveGeneralTab,
  savePageChange,
  setInitLangTemplate,
  getBlockByIndex,
  updateBlockIndex,
  updateCollectionType,
  updateBlockSettings,
  toggleShowHeader,
  addHeaderLink,
  addHeaderMenu,
  updateHeaderGroupe,
  toggleShowHeaderGroupe,
  removeHeaderGroupe,
  updateHeaderSubLink,
  createNewPage,
  getLangBlocks,
  addNewSetLink,
  changeSetsLang,
  setToEditSet,
  setListSets,
  updateSetData,
  updateHeaderMenu,
  updateSlug,
  checkValidatePage,
  updateInternalTitle,
  updatePropertyField,
  updatePageType,
  checkHasSetChanges,
  removeSetLink,
  updateSetLink,
  cancelSetsChanges,
  updateOrderSetLinks,
  updateLangPageData,
  validatePageRules,
  changeWidgetLang,
  checkHasWidgetChanges,
  toggleIsWidgetEditing,
  cancelWidgetChanges,
  updateWidget,
  convertToWidget,
  detachWidget,
  addWidgetToWidgetsList,
  addWidgetsToWidgetsList,
  updateWidgetTitle,
  startEditWidget,
  endEditWidget,
  updateDataWidget,
  toggleShowWidgetLang,
  setIsPageNotFound,
  getBlockLocale,
  actualizeSettings,
  updateIsHiddenPageForLang,
  updateIsHiddenPage,
  resetPageRules,
  resetBlockIndex,
  setPendingUserDeletionId,
  setPagesWithWidget,
} from "./actions";

import { getPageTypes, validationPageRules } from "@config/cms";
import getBlockTemplate from "@components/cmsBlocks/getBlockTemplate";
import { deepClone, cloneBlocks } from "@utils/cms";


const initPageRules = {
  ...Object.keys(validationPageRules).reduce((acc, key) => {
    acc[key] = false;
    return acc;
  }, {}),
};

const initialCmsState = {
  uiOptions: {
    isEditMode: false,
    isOpenSettings: false,
    isOpenGeneral: false,
    isOpenCreatePage: false,
    isActiveSeo: true,
    activeGeneralTab: "pages",
  },
  page: {
    // type: "home", // reqular, promo, news, story, route, destination
    lang: "en",
    data: {},
    draft: {},
    copyFrom: "empty",
    hasChanges: false,
    isLoading: false,
    blockIndex: null,
    collectionType: null,
    isNewPage: false,
    isValidPage: false,
    isPageNotFound: false,
    isWidget: false,
  },
  validations: {
    pageRules: initPageRules,
    headerRules: {},
    widgetRules: {},
    setRules: {},
  },
  header: {
    data: {},
    draft: {},
    lang: "en",
    hasChanges: false,
    isLoading: false,
    showHeader: false,
  },
  seo: {
    isCustomSlug: false,
  },
  settings: {
    isOpenSugg: false,
  },
  sets: {
    lang: "en",
    list: [],
    original: {},
    draft: {},
    hasChanges: false,
  },
  widget: {
    list: {},
    lang: "en",
    isWidgetEditing: false,
    hasChanges: false,
    original: {},
    draft: {},
    pendingUserDeletion: {
      id: "",
      usagePages: [],
    },
  },
};

export const cmsSlice = (set, get) => ({
  ...initialCmsState,
});

export const cmsActions = (set, get) => ({
  [createNewPage]: (newPage) => {
    set(
      produce((state) => {
        state.cms.page.data = newPage;
        state.cms.page.draft = newPage;
        // state.cms.page = {
        //   ...state.cms.page,
        // };
      }),
    );
  },
  [toggleEditMode]: (isEnabled = null) => {
    set(
      produce((state) => {
        const isEditMode = isEnabled ?? !state.cms.uiOptions.isEditMode;

        if (!isEditMode) {
          state.cms = {
            ...initialCmsState,
            uiOptions: {
              ...initialCmsState.uiOptions,
              isEditMode,
            },
          };
        } else {
          state.cms.uiOptions.isEditMode = isEditMode;
        }

        // if (isEditMode) {
        //   const data = state.cms.page.data;
        // }

        // if (isEnabled || !state.cms.uiOptions.isEditMode) {
        //   state.cms.uiOptions.isEditMode = true;
        // } else {
        //   state.cms.uiOptions.isEditMode =
        //     isEnabled ?? !state.cms.uiOptions.isEditMode;

        //   // state.cms = initialCmsState; // do this

        //   // remove this
        //   const data = state.cms.page.data;

        // state.cms = {
        //   ...initialCmsState,
        //   page: {
        //     ...initialCmsState.page,
        //     data,
        //   },
        // };
        // }
      }),
    );
  },
  [resetPageRules]: () => {
    set(
      produce((state) => {
        state.cms.validations.pageRules = initPageRules;
      }),
    );
  },
  [resetBlockIndex]: () => {
    set(
      produce((state) => {
        state.cms.page.blockIndex = null;
      }),
    );
  },
  [checkValidatePage]: () => {
    set(
      produce((state) => {
        const pageRules = get().cms.validations.pageRules;

        let isValidPage = Object.values(pageRules).every((rule) => {
          return rule;
        });

        const isPageRoute = get().cms.page.draft.type === getPageTypes().route;
        const isPageDestination =
          get().cms.page.draft.type === getPageTypes().destination;

        if (isPageRoute && isValidPage) {
          isValidPage =
            !!get().cms.page.draft.properties.from &&
            !!get().cms.page.draft.properties.to;
        }

        if (isPageDestination && isValidPage) {
          isValidPage = !!get().cms.page.draft.properties.destination;
        }

        if (isPageDestination && isValidPage) {
          isValidPage = !!get().cms.page.draft.properties.destination;
        }

        state.cms.page.isValidPage = isValidPage;
      }),
    );
  },
  [validatePageRules]: () => {
    set(
      produce((state) => {
        const lang = get().cms.page.lang;
        const hasChanges = get().cms.page.hasChanges;

        if (hasChanges) {
          const slug = get().cms.page.draft.languages[lang].slug;
          const internalTitle = get().cms.page.draft.languages[lang].title;
          const timePublished = get().cms.page.draft.properties.timePublished;

          state.cms.validations.pageRules.isValidInternalTitle =
            !!internalTitle;
          state.cms.validations.pageRules.isUniqueSlug = !!slug;
          state.cms.validations.pageRules.isValidTimePublished =
            !!timePublished;
        }

        // const pageRules = get().cms.validations.pageRules;

        // if (get().cms.page.draft.type === getPageTypes().route) {
        //   result =
        //     !!get().cms.page.draft.properties.from &&
        //     !!get().cms.page.draft.properties.to;
        // }

        // if (get().cms.page.draft.type === getPageTypes().destination) {
        //   result = !!get().cms.page.draft.properties.destination;
        // }

        // state.cms.page.isValidPage = result;
      }),
    );

    get().checkValidatePage();
  },
  [toggleActiveSeo]: (isActive = null) => {
    set(
      produce((state) => {
        state.cms.uiOptions.isActiveSeo = isActive;
      }),
    );
  },
  [setActiveGeneralTab]: (tab = "pages") => {
    set(
      produce((state) => {
        state.cms.uiOptions.activeGeneralTab = tab;
      }),
    );
  },
  [toggleGeneral]: (isOpen = null) => {
    set(
      produce((state) => {
        if (isOpen || !state.cms.uiOptions.isOpenGeneral) {
          state.cms.uiOptions.isOpenSettings = false;
          state.cms.uiOptions.isOpenCreatePage = false;
          state.cms.uiOptions.isOpenGeneral = true;
        } else {
          state.cms.uiOptions.isOpenGeneral =
            isOpen ?? !state.cms.uiOptions.isOpenGeneral;
        }
      }),
    );
  },
  [toggleSettings]: (isOpen = null) => {
    set(
      produce((state) => {
        if (isOpen || !state.cms.uiOptions.isOpenSettings) {
          state.cms.uiOptions.isOpenCreatePage = false;
          state.cms.uiOptions.isOpenGeneral = false;
          state.cms.uiOptions.isOpenSettings = true;
        } else {
          state.cms.uiOptions.isOpenSettings =
            isOpen ?? !state.cms.uiOptions.isOpenSettings;
        }
      }),
    );
  },
  [toggleShowHeader]: (isShow = null) => {
    set(
      produce((state) => {
        const isBoolean = (val) => Boolean(val) === val;

        if (isBoolean(isShow)) {
          state.cms.header.showHeader = isShow;
        } else {
          state.cms.header.showHeader = !state.cms.header.showHeader;
        }
      }),
    );
  },
  [toggleCreatePage]: (isOpen = null) => {
    set(
      produce((state) => {
        if (isOpen || !state.cms.uiOptions.isOpenCreatePage) {
          state.cms.uiOptions.isOpenSettings = false;
          state.cms.uiOptions.isOpenGeneral = false;
          state.cms.uiOptions.isOpenCreatePage = true;
        } else {
          state.cms.uiOptions.isOpenCreatePage =
            isOpen ?? !state.cms.uiOptions.isOpenCreatePage;
        }
      }),
    );
  },
  [changePageLang]: (lang) => {
    set(
      produce((state) => {
        state.cms.page.lang = lang;
      }),
    );
  },
  [changeHeaderLang]: (lang) => {
    set(
      produce((state) => {
        state.cms.header.lang = lang;
      }),
    );
  },
  [changeSetsLang]: (lang) => {
    set(
      produce((state) => {
        state.cms.sets.lang = lang;
      }),
    );
  },
  [changeWidgetLang]: (lang) => {
    set(
      produce((state) => {
        state.cms.widget.lang = lang;
      }),
    );
  },
  [cancelPageChanges]: () => {
    set(
      produce((state) => {
        const data = get().cms.page.data;

        state.cms.page.draft = deepClone(data);
      }),
    );

    get().resetBlockIndex();
    get().checkHasPageChanges();
  },
  [cancelHeaderChanges]: () => {
    set(
      produce((state) => {
        const data = get().cms.header.data;
        state.cms.header.draft = data;
      }),
    );

    get().checkHasHeaderChanges();
  },
  [changePage]: (payload) => {
    set(
      produce((state) => {
        state.cms.page = {
          ...state.cms.page,
          ...payload,
        };
      }),
    );

    get().checkHasPageChanges();
  },
  [updateLangPageData]: (payload) => {
    set(
      produce((state) => {
        const { data: langData, ...restPage } = payload;

        const lang = state.cms.page.lang;

        const updateLang = {
          ...state.cms.page.data,
          ...restPage,
          languages: {
            ...state.cms.page.data.languages,
            [lang]: langData,
          },
        };

        state.cms.page.data = updateLang;
        state.cms.page.draft = updateLang;
      }),
    );

    get().checkHasPageChanges();
  },
  [setInitLangTemplate]: (initTemplate) => {
    set(
      produce((state) => {
        const lang = state.cms.page.lang;

        state.cms.page.draft.languages[lang] = initTemplate;
      }),
    );
  },
  [hasSlug]: (lang) => {
    if (!lang) {
      console.error("hasSlug: lang not set");
      return false;
    }

    return get().cms.page?.data?.languages?.[lang]?.slug || false;

    // switch (get().cms.page.type) {
    //   case "home":
    //     return get().cms.page.data.slug;
    //   case "route":
    //     return get().cms.page.data[lang]?.slug;
    // }
  },
  [updateSlug]: (slug, isUniqueSlug) => {
    set(
      produce((state) => {
        const lang = state.cms.page.lang;

        state.cms.page.draft.languages[lang].slug = slug;
        state.cms.validations.pageRules.isUniqueSlug = !!slug && isUniqueSlug;
        // state.cms.page.isValidPage = isUniqueSlug;
      }),
    );

    // get().checkValidatePage();
    get().checkHasPageChanges();
  },
  [updateInternalTitle]: (title) => {
    set(
      produce((state) => {
        const lang = state.cms.page.lang;

        state.cms.page.draft.languages[lang].title = title;
        state.cms.validations.pageRules.isValidInternalTitle = !!title;
      }),
    );

    // get().checkValidatePage();
    get().checkHasPageChanges();
  },
  [getIsPublishedLang]: (lang) => {
    if (!lang) {
      return console.error("getIsPublishedLang: lang not set");
    }

    if (!get().cms.page.data.languages[lang]) {
      console.error(
        `getIsPublishedLang page does not have data for ${lang} lang`,
      );
    }

    return get().cms.page.data.languages[lang]?.isPublished; // maybe correct get from draft object
  },
  [updatePageDataField]: (field) => {
    set(
      produce((state) => {
        const lang = state.cms.page.lang;

        state.cms.page.draft.languages[lang].pageData[field.name] = field.value;
      }),
    );

    get().checkHasPageChanges();
  },
  [updateSeoField]: (field) => {
    set(
      produce((state) => {
        const lang = state.cms.page.lang;

        state.cms.page.draft.languages[lang].seo[field.name] = field.value;
      }),
    );

    // get().checkValidatePage();
    get().checkHasPageChanges();
  },
  [updatePropertyField]: (field) => {
    set(
      produce((state) => {
        const properties = state.cms.page.draft.properties;

        state.cms.page.draft.properties = {
          ...properties,
          ...field,
        };
      }),
    );

    // get().checkValidatePage();
    get().checkHasPageChanges();
  },
  [updatePageType]: (nextType) => {
    set(
      produce((state) => {
        state.cms.page.draft.type = nextType;
      }),
    );

    get().checkHasPageChanges();
    get().validatePageRules();
  },
  [updateIsPublishedPageForLang]: () => {
    set(
      produce((state) => {
        const lang = state.cms.page.lang;

        state.cms.page.draft.languages[lang].isPublished =
          !state.cms.page.draft.languages[lang].isPublished;
      }),
    );

    get().checkHasPageChanges();
  },
  [updateIsPublishedPage]: () => {
    set(
      produce((state) => {
        state.cms.page.draft.isPublished = !state.cms.page.draft.isPublished;
      }),
    );

    get().checkHasPageChanges();
  },
  [updateIsHiddenPageForLang]: () => {
    set(
      produce((state) => {
        const lang = state.cms.page.lang;

        state.cms.page.draft.languages[lang].hidden =
          !state.cms.page.draft.languages[lang].hidden;
      }),
    );

    get().checkHasPageChanges();
  },
  [updateIsHiddenPage]: () => {
    set(
      produce((state) => {
        state.cms.page.draft.hidden = !state.cms.page.draft.hidden;
      }),
    );

    get().checkHasPageChanges();
  },
  [checkHasPageChanges]: () => {
    set(
      produce((state) => {
        const hasChanges = isEqual(get().cms.page.draft, get().cms.page.data);

        state.cms.page.hasChanges = !hasChanges;
      }),
    );

    get().validatePageRules();
  },
  // [savePageChange]: () => {
  //   set(
  //     produce((state) => {
  //       const lang = state.cms.page.lang;

  //       state.cms.page.data.languages[lang] =
  //         state.cms.page.draft.languages[lang];
  //     })
  //   );

  //   get().checkHasPageChanges();
  // },
  [setTemplate]: (payload) => {
    set(
      produce((state) => {
        // console.log('setTemplate', data);
        // const data = {
        //   // seo: {
        //   //   ...payload.seo,
        //   //   slug: '',
        //   // },
        //   seo: payload.seo,
        //   isPublished: payload.isPublished,
        //   title: payload.title,
        // }
        const lang = state.cms.page.lang;
        state.cms.page.draft.languages[lang] = payload;
      }),
    );

    get().checkHasPageChanges();
  },
  [updateOrderBlocks]: (blocks) => {
    set(
      produce((state) => {
        const lang = state.cms.page.lang;

        const clonedBlocks = cloneBlocks(blocks);

        state.cms.page.draft.languages[lang].pageData.blocks = clonedBlocks;
      }),
    );

    get().resetBlockIndex();
    get().checkHasPageChanges();
  },
  [toggleShowBlock]: (index) => {
    set(
      produce((state) => {
        const lang = state.cms.page.lang;
        const isShow =
          state.cms.page.draft.languages[lang].pageData.blocks[index].isShow;

        state.cms.page.draft.languages[lang].pageData.blocks[index].isShow =
          !isShow;
      }),
    );

    get().checkHasPageChanges();
  },
  [removeBlock]: (index) => {
    set(
      produce((state) => {
        const lang = state.cms.page.lang;

        const blocks = state.cms.page.draft.languages[
          lang
        ].pageData.blocks.filter((i, key) => key !== index);

        state.cms.page.draft.languages[lang].pageData.blocks = blocks;

        if (!blocks.length) {
          state.cms.page.draft.languages[lang].isPublished = false;
        }
      }),
    );

    get().resetBlockIndex();
    get().checkHasPageChanges();
  },
  [addBlock]: (block, position) => {
    set(
      produce((state) => {
        const lang = state.cms.page.lang;

        const blocks = [
          ...(get().cms.page.draft.languages[lang].pageData.blocks || []),
        ];

        const clonedBlock = deepClone(block);

        blocks.splice(position, 0, clonedBlock);

        state.cms.page.draft.languages[lang].pageData.blocks = cloneBlocks(blocks);
      }),
    );

    get().resetBlockIndex();
    get().checkHasPageChanges();
  },
  [updateDataBlock]: (payload, index) => {
    set(
      produce((state) => {
        try {
          const lang = state.cms.page.lang;
          const blocks = state.cms.page.draft.languages[lang].pageData.blocks;

          const targetIndex = index !== undefined ? index : state.cms.page.blockIndex;

          if (targetIndex === null || targetIndex < 0 || targetIndex >= blocks.length) {
            console.warn('Invalid block index for updateDataBlock:', targetIndex, 'blocks length:', blocks.length);
            return;
          }

          if (Array.isArray(payload)) {
            payload.forEach((field) => {
              blocks[targetIndex].data[field.name] = field.value;
            });

            return;
          }

          blocks[targetIndex].data[payload.name] = payload.value;
        } catch (e) {
          console.error("[updateDataBlock]", e);
        }
      }),
    );

    get().checkHasPageChanges();
  },
  [updateDataWidget]: (payload) => {
    set(
      produce((state) => {
        const lang = state.cms.widget.lang;

        if (Array.isArray(payload)) {
          payload.forEach((field) => {
            state.cms.widget.draft.languages[lang].data[field.name] =
              field.value;
          });

          return;
        }

        state.cms.widget.draft.languages[lang].data[payload.name] =
          payload.value;
      }),
    );

    get().checkHasWidgetChanges();
  },
  [actualizeSettings]: (index) => {
    set(
      produce((state) => {
        const widgetLang = state.cms.widget.lang;
        const pageLang = state.cms.page.lang;
        const isWidgetEditing = state.cms.widget.isWidgetEditing;

        if (isWidgetEditing) {
          const currentSettings =
            state.cms.widget.draft.languages[widgetLang].settings;
          state.cms.widget.draft.languages[widgetLang].settings = {
            common: {
              ...defaultBlockSettings.common,
              ...currentSettings.common,
            },
            specific: {
              // ...defaultBlockSettings.specific, // TODO: correct use defaultBlockSettings.specific[BLOCK_NAME]
              ...currentSettings.specific,
            },
          };
        } else {
          const currentSettings =
            get().cms.page.draft.languages[pageLang].pageData.blocks[index]
              .settings;

          state.cms.page.draft.languages[pageLang].pageData.blocks[
            index
          ].settings = {
            common: {
              ...defaultBlockSettings.common,
              ...currentSettings.common,
            },
            specific: {
              // ...defaultBlockSettings.specific, // TODO: correct use defaultBlockSettings.specific[BLOCK_NAME]
              ...currentSettings.specific,
            },
          };
        }
      }),
    );
  },
  [updateBlockSettings]: (payload, index, typeSettings) => {
    get().actualizeSettings(index);
    set(
      produce((state) => {
        try {
          const widgetLang = state.cms.widget.lang;
          const pageLang = state.cms.page.lang;
          const isWidgetEditing = state.cms.widget.isWidgetEditing;

          if (isWidgetEditing) {
            if (Array.isArray(payload)) {
              payload.forEach((field) => {
                state.cms.widget.draft.languages[widgetLang].settings[
                  typeSettings
                ][field.name].value = field.value;
              });

              return;
            }

            state.cms.widget.draft.languages[widgetLang].settings[typeSettings][
              payload.name
            ].value = payload.value;
          } else {
            if (Array.isArray(payload)) {
              payload.forEach((field) => {
                state.cms.page.draft.languages[pageLang].pageData.blocks[
                  index
                ].settings[typeSettings][field.name].value = field.value;
              });

              return;
            }

            state.cms.page.draft.languages[pageLang].pageData.blocks[
              index
            ].settings[typeSettings][payload.name].value = payload.value;
          }
        } catch (e) {
          console.error("[updateBlockSettings]", e);
        }
      }),
    );

    get().checkHasPageChanges();
    get().checkHasWidgetChanges();
  },
  [getBlockByIndex]: (index) => {
    const lang = get().cms.page.lang;
    const blockIndex = get().cms.page.blockIndex;

    const idx = index ?? blockIndex;

    return get().cms.page.draft.languages[lang].pageData.blocks[idx];
  },
  [getLangBlocks]: (lang) => {
    if (!lang) {
      const lang = get().cms.page.lang;
      return get().cms.page.draft.languages[lang].pageData.blocks;
    }

    if (lang) {
      const langData = get().cms.page.draft.languages[lang];

      return langData?.pageData?.blocks || [];
    }
  },
  [updateBlockIndex]: (index, isWidget = null) => {
    set(
      produce((state) => {
        if (index === null || index === undefined) {
          state.cms.page.blockIndex = null;
          return;
        }

        const lang = state.cms.page.lang;

        const blocks = state.cms.page.draft.languages?.[lang]?.pageData?.blocks;

        if (!blocks) {
          // console.warn('No blocks found for lang:', lang);
          return;
        }

        if (index >= 0 && index < blocks.length) {
          state.cms.page.blockIndex = index;
          if (Boolean(isWidget) === isWidget) {
            state.cms.page.isWidget = isWidget;
          }
        } else {
          console.warn('Invalid block index for updateBlockIndex:', index, 'blocks length:', blocks.length);
          state.cms.page.blockIndex = null;
        }
      }),
    );
  },
  [updateCollectionType]: (event) => {
    set(
      produce((state) => {
        try {
          const blockIndex =
            event.target.closest("[data-block-index]")?.dataset?.blockIndex;
          const collectionType = event.target.closest("[data-collection-type]")
            ?.dataset?.collectionType;
          Number.isInteger(Number(blockIndex)) &&
            get().updateBlockIndex(Number(blockIndex));

          state.cms.page.collectionType = collectionType;
        } catch (error) {
          console.error(`'[updateCollectionType]': ${error.message}`);
        }
      }),
    );

    get().updateModals({
      isOpenEditCollectionModal: true,
    });
  },
  [removeLang]: () => {
    set(
      produce((state) => {
        const lang = state.cms.page.lang;

        state.cms.page.draft.languages[lang] = null;
      }),
    );

    get().checkHasPageChanges();
  },
  [setIsPageNotFound]: (value = false) => {
    set(
      produce((state) => {
        state.cms.page.isPageNotFound = value;
      }),
    );
  },
  [removePage]: () => {},

  // ========== H E A D E R ==========
  [checkHasHeaderChanges]: () => {
    set(
      produce((state) => {
        const hasChanges = isEqual(
          state.cms.header.draft,
          state.cms.header.data,
        );

        state.cms.header.hasChanges = !hasChanges;
      }),
    );
  },
  [updateOrderHeaderGroupes]: (routes) => {
    set(
      produce((state) => {
        const lang = state.cms.header.lang;

        state.cms.header.draft[lang] = routes;
      }),
    );

    get().checkHasHeaderChanges();
  },
  [toggleShowHeaderGroupe]: (index) => {
    set(
      produce((state) => {
        const lang = state.cms.header.lang;
        const isShow = state.cms.header.draft[lang][index].isShow;

        state.cms.header.draft[lang][index].isShow = !isShow;
      }),
    );

    get().checkHasHeaderChanges();
  },
  [removeHeaderGroupe]: (index) => {
    set(
      produce((state) => {
        const lang = state.cms.header.lang;

        const groupes = state.cms.header.draft[lang].filter(
          (i, key) => key !== index,
        );

        state.cms.header.draft[lang] = groupes;
      }),
    );

    get().checkHasHeaderChanges();
  },
  [updateOrderHeaderSubLinks]: (links, groupeIndex) => {
    set(
      produce((state) => {
        const lang = state.cms.header.lang;

        state.cms.header.draft[lang][groupeIndex].links = links;
      }),
    );

    get().checkHasHeaderChanges();
  },
  [updateHeaderMenu]: (headerMenu) => {
    set(
      produce((state) => {
        const lang = state.cms.header.lang;

        state.cms.header.draft = headerMenu;
        state.cms.header.data = headerMenu;
      }),
    );

    get().checkHasHeaderChanges();
  },
  [updateHeaderGroupe]: (groupe, groupeIndex) => {
    set(
      produce((state) => {
        const lang = state.cms.header.lang;

        state.cms.header.draft[lang][groupeIndex] = groupe;
      }),
    );

    get().checkHasHeaderChanges();
  },
  [updateHeaderSubLink]: (link, groupeIndex, index) => {
    set(
      produce((state) => {
        const lang = state.cms.header.lang;

        state.cms.header.draft[lang][groupeIndex].links[index] = link;
      }),
    );

    get().checkHasHeaderChanges();
  },
  [toggleShowHeaderSubLink]: (gpoupeIndex, linkIndex) => {
    set(
      produce((state) => {
        const lang = state.cms.header.lang;
        const isShow =
          state.cms.header.draft[lang][gpoupeIndex].links[linkIndex].isShow;

        state.cms.header.draft[lang][gpoupeIndex].links[linkIndex].isShow =
          !isShow;
      }),
    );

    get().checkHasHeaderChanges();
  },
  [removeHeaderSubLink]: (gpoupeIndex, linkIndex) => {
    set(
      produce((state) => {
        const lang = state.cms.header.lang;

        const links = state.cms.header.draft[lang][gpoupeIndex].links.filter(
          (i, key) => key !== linkIndex,
        );

        state.cms.header.draft[lang][gpoupeIndex].links = links;
      }),
    );

    get().checkHasHeaderChanges();
  },
  [addHeaderLink]: (groupeIndex, link, index) => {
    set(
      produce((state) => {
        const lang = state.cms.header.lang;

        const links = [
          ...(get().cms.header.draft[lang][groupeIndex].links || []),
        ];

        links.splice(index, 0, link);

        state.cms.header.draft[lang][groupeIndex].links = links;
      }),
    );

    get().checkHasHeaderChanges();
  },
  [addHeaderMenu]: (menuIndex, menu) => {
    set(
      produce((state) => {
        const lang = state.cms.header.lang;

        const menus = [...(get().cms.header.draft[lang] || [])];

        menus.splice(menuIndex, 0, menu);

        state.cms.header.draft[lang] = menus;
      }),
    );

    get().checkHasHeaderChanges();
  },

  // ========== S E T S ==========
  [checkHasSetChanges]: () => {
    set(
      produce((state) => {
        const draft = state.cms.sets.draft.data.filter((i) => !i.isNew);
        const hasChanges = isEqual(draft, state.cms.sets.original.data);

        state.cms.sets.hasChanges = !hasChanges;
      }),
    );
  },
  [cancelSetsChanges]: () => {
    set(
      produce((state) => {
        state.cms.sets.draft = state.cms.sets.original;
      }),
    );

    get().checkHasSetChanges();
  },
  [updateOrderSetLinks]: (links) => {
    set(
      produce((state) => {
        state.cms.sets.draft.data = links;
      }),
    );

    get().checkHasSetChanges();
  },
  [addNewSetLink]: (link, index) => {
    set(
      produce((state) => {
        const items = [...(get().cms.sets.draft.data || [])];

        items.splice(index, 0, link);

        state.cms.sets.draft.data = items;
      }),
    );

    get().checkHasSetChanges();
  },
  [updateSetLink]: (link, index) => {
    set(
      produce((state) => {
        state.cms.sets.draft.data[index] = link;
      }),
    );

    get().checkHasSetChanges();
  },
  [removeSetLink]: (index) => {
    set(
      produce((state) => {
        const links = state.cms.sets.draft.data.filter(
          (i, key) => key !== index,
        );

        state.cms.sets.draft.data = links;
      }),
    );

    get().checkHasSetChanges();
  },
  [setToEditSet]: (setToEdit) => {
    set(
      produce((state) => {
        state.cms.sets.original = setToEdit;
        state.cms.sets.draft = setToEdit;
      }),
    );

    get().checkHasSetChanges();
  },
  [updateSetData]: (setData) => {
    set(
      produce((state) => {
        state.cms.sets.draft.data = setData;
      }),
    );
  },
  [setListSets]: (list) => {
    set(
      produce((state) => {
        state.cms.sets.list = list;
      }),
    );
  },

  // ========== WIDGET ==========
  [toggleIsWidgetEditing]: (isEnabled = null) => {
    set(
      produce((state) => {
        const isBoolean = (val) => Boolean(val) === val;

        if (isBoolean(isEnabled)) {
          // const draft = state.cms.widget.draft;
          // console.log("toggleIsWidgetEditing draft", draft);
          // const block = getBlockTemplate(draft.type);
          // const { languages, ...rest } = draft;

          // const newLanguages = {};

          // Object.entries(languages).forEach(([lang, data]) => {
          //   newLanguages[lang] = data || block.initEmptyData;
          // });

          // const updateWidget = {
          //   ...rest,
          //   languages: newLanguages,
          // };

          // get().updateWidget(updateWidget);

          state.cms.widget.isWidgetEditing = isEnabled;
        } else {
          // const id = state.cms.widget.draft.id;
          // const list = state.cms.widget.list;
          // delete list[id];
          // state.cms.widget.list = list;
          // state.cms.widget.draft = {};
          // state.cms.widget.original = {};
          state.cms.widget.isWidgetEditing = !state.cms.widget.isWidgetEditing;
        }
      }),
    );
  },
  [toggleShowWidgetLang]: (widgetId, lang) => {
    set(
      produce((state) => {
        const isShow = state.cms.widget.draft.languages[lang].isShow;
        state.cms.widget.draft.languages[lang].isShow = !isShow;
      }),
    );

    get().checkHasWidgetChanges();
  },
  [updateWidget]: (payload) => {
    // payload = full widget
    set(
      produce((state) => {
        const block = getBlockTemplate(payload.type);
        const { languages, ...rest } = payload;

        const newLanguages = {};

        const emptyLanguage = {
          data: block.initEmptyData,
          settings: block.block.settings,
        };

        Object.entries(languages).forEach(([lang, data]) => {
          newLanguages[lang] = data || emptyLanguage;
        });

        const widget = {
          ...rest,
          languages: newLanguages,
        };

        state.cms.widget.original = widget;
        state.cms.widget.draft = widget;
      }),
    );

    get().checkHasWidgetChanges();
  },
  [startEditWidget]: () => {
    set(
      produce((state) => {
        const draft = state.cms.widget.draft;
        const block = getBlockTemplate(draft.type);
        const { languages, ...rest } = draft;

        const newLanguages = {};

        Object.entries(languages).forEach(([lang, data]) => {
          newLanguages[lang] = data || block.initEmptyData;
        });

        const updateWidget = {
          ...rest,
          languages: newLanguages,
        };
      }),
    );
  },
  [endEditWidget]: () => {
    set(
      produce((state) => {
        const id = state.cms.widget.draft.id;
        const list = state.cms.widget.list;
        delete list[id];
        state.cms.widget.list = list;
        state.cms.widget.draft = {};
        state.cms.widget.original = {};
      }),
    );
  },
  [checkHasWidgetChanges]: () => {
    set(
      produce((state) => {
        const hasChanges = isEqual(
          state.cms.widget.draft,
          state.cms.widget.original,
        );

        state.cms.widget.hasChanges = !hasChanges;
      }),
    );
  },
  [cancelWidgetChanges]: () => {
    set(
      produce((state) => {
        const data = get().cms.widget.original;
        state.cms.widget.draft = data;
      }),
    );

    get().checkHasWidgetChanges();
  },
  [convertToWidget]: (index, widgetId, widgetType) => {
    set(
      produce((state) => {
        const lang = state.cms.page.lang;
        const isShow =
          state.cms.page.draft.languages[lang].pageData.blocks[index].isShow;

        state.cms.page.draft.languages[lang].pageData.blocks[index] = {
          widgetId,
          isShow,
          widgetType,
        };
      }),
    );

    get().checkHasPageChanges();
  },
  [detachWidget]: (index, isShow, widgetId) => {
    set(
      produce((state) => {
        const lang = state.cms.page.lang;

        const widget = state.cms.widget.list[widgetId];

        const widgetLangData = widget.languages[lang];

        state.cms.page.draft.languages[lang].pageData.blocks[index] = {
          isShow,
          name: widget.type,
          ...widgetLangData,
        };
      }),
    );

    get().checkHasPageChanges();
  },
  [addWidgetToWidgetsList]: (widget) => {
    set(
      produce((state) => {
        const widgets = { ...state.cms.widget.list };

        widgets[widget.id] = { ...widget };

        state.cms.widget.list = widgets;
      }),
    );
  },
  [addWidgetsToWidgetsList]: (widgetsList) => {
    set(
      produce((state) => {
        const widgets = widgetsList.reduce((result, item) => {
          result[item.id] = item;
          return result;
        }, {});

        state.cms.widget.list = widgets;
      }),
    );
  },
  [updateWidgetTitle]: (title) => {
    set(
      produce((state) => {
        state.cms.widget.draft.title = title;
      }),
    );

    get().checkHasWidgetChanges();
  },
  [getBlockLocale]: (locale) => {
    if (!locale) {
      console.log("[getBlockLocale]: Missing locale parament");
    }

    const isWidgetEditing = get().cms.widget.isWidgetEditing;
    const isEditMode = get().cms.uiOptions.isEditMode;
    return isEditMode
      ? isWidgetEditing
        ? get().cms.widget.lang
        : get().cms.page.lang
      : locale;
  },
  [setPendingUserDeletionId]: (id) => {
    set(
      produce((state) => {
        state.cms.widget.pendingUserDeletion.id = id;
      }),
    );
  },
  [setPagesWithWidget]: (pages) => {
    set(
      produce((state) => {
        state.cms.widget.pagesWithWidget = pages;
      }),
    );
  },
});
